"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function emit(element, eventOrName, detail, eventParams) {
    // we will do this async
    setTimeout(function () {
        var event;
        if (typeof eventOrName === 'string') {
            event = element.ownerDocument.createEvent('CustomEvent');
            var eventInitParams = tslib_1.__assign({ bubbles: true, cancelable: true, detail: detail }, eventParams);
            if (event.initCustomEvent) {
                event.initCustomEvent(eventOrName, eventInitParams.bubbles, eventInitParams.cancelable, eventInitParams.detail);
            }
            else {
                event.initEvent(eventOrName, eventInitParams.bubbles, eventInitParams.cancelable);
                event.detail = eventInitParams.detail;
            }
        }
        else {
            event = eventOrName;
        }
        element.dispatchEvent(event);
    });
}
exports.emit = emit;
